import { API } from '../config';

export const API_URLS = {
  LOGIN: `${API.login}`,

  LOGOUT: `${API.logout}`,

  REFRESH_TOKEN: `${API.refresh}`,

  SESSION_ACTIVITY: `${API.sessionActivity}`,

  SECURITY_SETTINGS_CLIENTS: `${API.securitySettingsClients}`,
  SECURITY_SETTINGS_CLIENT: (clientId: string) => API.securitySettingsClient(clientId),
  SESSION_EXEMPTIONS: `${API.sessionExemptions}`,
  SESSION_EXEMPTION: (userId: string) => API.sessionExemption(userId),
  CLIENT_SUSPENSION: (clientId: string) => API.clientSuspension(clientId),
  USER_BLOCK: (userId: string) => API.userBlock(userId),
  USER_CLIENTS: (userId: string) => API.userClients(userId),
  USER_CLIENT: (userId: string, clientId: string) => API.userClient(userId, clientId),

  GET_CLIENTS: `${API.getClients}`,

  GET_CLIENTS_FEATURES: `${API.getClientsFeatures}`,

  SET_CLIENT_FEATURES: (clientId: string) => API.setClientFeatures(clientId),

  GET_SUPERVISORS: `${API.getSupervisors}`,
  SET_SUPERVISOR_FLAG: (clientId: string) => API.setSupervisorFlag(clientId),
  UPSERT_SUPERVISOR_MAPPING: (supervisorId: string) => API.upsertSupervisorMapping(supervisorId),
  DELETE_SUPERVISOR_MAPPING: (supervisorId: string, tenantOrPortfolioId: string) =>
    API.deleteSupervisorMapping(supervisorId, tenantOrPortfolioId),

  GET_ONBOARDING_DOMAINS: `${API.getOnboardingDomains}`,
  ADD_ONBOARDING_DOMAIN: `${API.addOnboardingDomain}`,
  DELETE_ONBOARDING_DOMAIN: (domain: string) => API.deleteOnboardingDomain(domain),

  DOCUMENT_SCANNING_LIBRARY: API.documentScanningLibrary,
  DOCUMENT_SCANNING_PROVIDER: API.documentScanningProvider,
  DOCUMENT_SCANNING_TYPES: API.documentScanningTypes,
  DOCUMENT_SCANNING_TYPE: API.documentScanningType,
  DOCUMENT_SCANNING_CHECKS: API.documentScanningChecks,
  DOCUMENT_SCANNING_CHECK: API.documentScanningCheck,
  DOCUMENT_SCANNING_ARCHIVE: API.documentScanningArchive,
  DOCUMENT_SCANNING_RESTORE: API.documentScanningRestore,

  GET_CLIENTS_COMMITMENTS: `${API.getClientsCommitments}`,

  SET_CLIENT_COMMITMENTS: (clientId: string) => API.setClientCommitments(clientId),

  INVITE_USER: `${API.inviteUser}`,

  CREATE_CLIENT: `${API.createClient}`,

  GET_CLIENT_BY_ID: (clientId: string) => `${API.createClient}/${clientId}`,

  GET_USERS: `${API.getUsers}`,
  DELETE_USER: (userId: string) => API.deleteUser(userId),
  UPDATE_USER: (userId: string) => API.updateUser(userId),

  GET_MATCHES: (companyId: string) => `${API.getMatches}/${companyId}`,

  GET_COMPANIES: `${API.getCompanies}`,

  UPDATE_MATCHES: `${API.updateMatches}`,

  GET_RELATED_INFO_LOGS: `${API.relatedInfoLogs}`,

  GET_CLIENTS_STATISTIC: `${API.clientsStatistic}`,

  GET_CLIENTS_COMPANIES: `${API.clientsCompanies}`,

  GET_ALL_COMPANIES_LIST: `${API.allCompaniesList}`,

  RELOAD_SERVICES: (companyId: string) => `${API.reloadService}/${companyId}`,

  DOWNLOAD_PDF: (clientId: string, companyId: string) =>
    `${API.downloadPdf}/${clientId}/company/${companyId}`,

  GET_USAGE_CATALOGUE: `${API.usageCatalogue}`,

  GET_USAGE_SUMMARY: `${API.usageSummary}`,

  GET_USAGE_TIMESERIES: `${API.usageTimeseries}`,

  GET_USAGE_BREAKDOWN: `${API.usageBreakdown}`,

  GET_USAGE_CLIENTS: `${API.usageClients}`,

  GET_USAGE_EVENTS: `${API.usageEvents}`,

  GET_USAGE_EXPORT: `${API.usageExport}`,

  GET_USAGE_HEALTH: `${API.usageHealth}`,

  GET_USAGE_PORTFOLIOS: `${API.usagePortfolios}`,

  GET_USAGE_TRANSACTIONS: `${API.usageTransactions}`,

  GET_USAGE_DOMAINS: `${API.usageDomains}`,

  GET_SUPPLIER_PULLS: `${API.supplierPulls}`,

  // Transactions API setup page
  TX_API_CLIENTS: `${API.txApiClients}`,
  TX_API_CLIENT: (clientId: string) => API.txApiClient(clientId),
  TX_API_KEYS: (clientId: string) => API.txApiKeys(clientId),
  TX_API_KEY: (clientId: string, keyId: string) => API.txApiKey(clientId, keyId),
  TX_API_KEY_ROTATE: (clientId: string, keyId: string) => API.txApiKeyRotate(clientId, keyId),
  TX_API_POLICY: (clientId: string) => API.txApiPolicy(clientId),
  TX_API_REGISTRATIONS: (clientId: string) => API.txApiRegistrations(clientId),
  TX_API_LOG: (clientId: string) => API.txApiLog(clientId),
  TX_API_LOG_SUMMARY: (clientId: string) => API.txApiLogSummary(clientId),
  TX_API_SIGNING_EXAMPLE: `${API.txApiSigningExample}`,
  TX_API_WEBHOOK_PROVIDERS: `${API.txApiWebhookProviders}`,
  TX_API_WEBHOOKS: (clientId: string) => API.txApiWebhooks(clientId),
  TX_API_WEBHOOK: (clientId: string, webhookId: string) => API.txApiWebhook(clientId, webhookId),
  TX_API_WEBHOOK_ROTATE: (clientId: string, webhookId: string) =>
    API.txApiWebhookRotate(clientId, webhookId),
};
